<template>
  <div class="max-w-6xl mx-auto px-4 sm:px-6">
    <div class="text-center pb-12">
      <div>
        <div class="mt-1">
          <input id="url-id-input" v-model="value" @keyup.enter="submit" type="text" :class="{ 'x-disabled': disabled }" autocomplete="on" class="x-form-input md:max-w-1/2 w-full" :placeholder="placeholder" :aria-label="placeholder" />
        </div>
        <div>
          <button id="submit-button" class="mt-8 x-button" :class="{ 'x-disabled': disabled }" @click="submit">
            <span v-if="loading">Loading...</span>
            <span v-else>Submit</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import * as api from "../code/youtube.thumbnail.downloader.definitions.api";
import * as app from "../code/youtube.thumbnail.downloader.definitions.app";
import * as www from "../code/youtube.thumbnail.downloader.definitions.www";

export default {
  setup() {
    //
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    error: {
      type: Object as PropType<www.error.schema>,
      required: true
    },
    modelValue: String
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value: any) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  watch: {
    error(n, o) {
      // console.log(n.exists, "test");
    }
  },
  emits: {
    "update:modelValue": null,
    submit: null,
    reset: null
  },
  mounted() {
    //
  },
  data() {
    return {
      input: "",
      placeholder: "YouTube video URL or ID"
    };
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    reset() {
      this.$emit("reset");
    }
  }
};
</script>
